// extracted by mini-css-extract-plugin
export default {"root":"Rating_root__j1xoj","iconStar":"Rating_iconStar__WrLfv"};